import { render, staticRenderFns } from "./PacienteCard.vue?vue&type=template&id=4b20670b&"
import script from "./PacienteCard.vue?vue&type=script&lang=js&"
export * from "./PacienteCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports